import { store } from '../../../configureStore';
import { apiUrls } from '../../../constants/apiUrl';
import { goToProcessStep } from '../../../redirection';
import {
  cartContactInfoIntg,
  checkIsMidnight,
  getFlowType,
  getSession,
  isACPEligibile,
  isCBandProQualifiedSession,
  isPreorder,
  isVFEligibile,
} from '../Helpers';
import { SETUP_OPTION_SELF, SETUP_OPTION_PROF } from '../../Web/DeviceSetup/constants';

export const isSaveCartDisplay = (currentPageName, appId) => {
  const isSaveCart = currentPageName === 'cart' && !isACPEligibile() && !isVFEligibile() && appId !== 'AAL';

  return isSaveCart;
};

export const isHideViewCart = (currentPageName) => {
  const enableMiniCartPages = ['cart', 'revieworder', 'orderreview', 'confirmation'];
  const hideViewCart = enableMiniCartPages.includes(currentPageName);

  return hideViewCart;
};

export const isDisplayOneTimeCharges = (currentPageName, selectedSetup) => {
  const isOneTimeCharges =
    selectedSetup === 'Professional SetUp' && currentPageName !== 'setup' && currentPageName !== 'addons' && getFlowType() === '5G';

  return isOneTimeCharges;
};

export const miniCartBackHandler = (currentPageName, appId, history) => {
  try {
    let updateView;
    const { processSteps, deviceSetup } = store.getState();
    const installType = deviceSetup?.selectedOption || '';
    const isPreorderFlow = isPreorder();
    const flowType = getSession('FlowType');
    switch (currentPageName) {
      case 'cart':
        if (flowType === '5G') {
          if (getSession('isCBandQual') === 'Y' && !isCBandProQualifiedSession()) {
            window.location.href = apiUrls().redirectAddons;
          } else if (isCBandProQualifiedSession()) {
            window.location.href = apiUrls().redirectSetup;
          } else {
            window.location.href = apiUrls().redirectSetup;
          }
        } else {
          window.location.href = apiUrls().redirectAddons;
        }
        break;

      case 'setup':
        window.location.href = apiUrls().redirectAddons;
        break;

      case 'addons':
        if (checkIsMidnight()) {
          history.push('progressiveplan.html');
        } else {
          window.location.href = apiUrls().redirectCBandPlans;
        }
        break;

      case 'appointment':
        history.push('orderreview.html');
        break;

      case 'orderreview':
        if (appId === 'AAL') {
          if (installType === SETUP_OPTION_PROF) {
            // If professional then rediect to contactinfo page
            if (cartContactInfoIntg()) {
              updateView = processSteps?.Setup?.SELF;
            } else {
              updateView = processSteps?.Cart;
            }
          } else if (installType === SETUP_OPTION_SELF && !isPreorderFlow) {
            // If self then rediect to shipping
            updateView = processSteps?.ContactInfo?.SELF;
          } else {
            // If no setup page then rediect to contactinfo page
            updateView = processSteps?.Cart;
          }
        } else {
          // NSE - redirect to creditcheck page
          updateView = processSteps?.Shipping?.CreditCheck;
        }
        goToProcessStep(updateView, history);
        break;
      case 'contactinfo':
        history.push('cart.html');

        goToProcessStep(processSteps.Setup.SELF, history);
        break;

      case 'creditcheck':
        if (installType === SETUP_OPTION_SELF && !isPreorderFlow) {
          // If self then rediect to shipping
          updateView = processSteps?.ContactInfo?.SELF;
        } else {
          // rediect to contactinfo page
          updateView = processSteps?.Cart;
        }
        goToProcessStep(updateView, history);
        break;

      case 'shipping':
        if (cartContactInfoIntg()) {
          history.push('cart.html');
          goToProcessStep(processSteps.Setup.SELF, history);
        } else {
          updateView = processSteps?.Cart;
          goToProcessStep(updateView, history);
        }
        break;

      default:
        history.goBack();
        break;
    }
  } catch (error) {
    console.log('error in MiniCartBackHandler', error);
  }
};
